document.querySelector(
  'link[rel="icon"]'
).href = `/${process.env.REACT_APP_FAVICON_LOGO}`;
